import FirstColumn from './FirstColumn'
import SecondColumn from './SecondColumn'
import { Wrapper, Image, Columns } from './_styles'
import { getScaledImage } from 'utils/screen'

const Content = ({ product }) => {
  const bottleImage = product?.bottleImagePreview?.thumbnailUrl
    ? getScaledImage(product?.bottleImagePreview)
    : product?.bottleImage?.imageUrl

  return (
    <Wrapper>
      <Image src={bottleImage} />
      <Columns>
        <FirstColumn product={product} />
        <SecondColumn product={product} />
      </Columns>
    </Wrapper>
  )
}

export default Content
